module.exports = __webpack_public_path__ + "static/media/pr.db39d157.svg";